import { render, staticRenderFns } from "./commonThirdSubFolder.vue?vue&type=template&id=0af11d64&scoped=true"
import script from "./commonThirdSubFolder.vue?vue&type=script&lang=js"
export * from "./commonThirdSubFolder.vue?vue&type=script&lang=js"
import style0 from "./commonThirdSubFolder.vue?vue&type=style&index=0&id=0af11d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af11d64",
  null
  
)

export default component.exports